export default __webpack_public_path__ + "static/media/footer_waves.e857645d.svg";